import { render, staticRenderFns } from "./FarmaciaPlus.vue?vue&type=template&id=faa33182&scoped=true"
import script from "./FarmaciaPlus.vue?vue&type=script&lang=js"
export * from "./FarmaciaPlus.vue?vue&type=script&lang=js"
import style0 from "./FarmaciaPlus.vue?vue&type=style&index=0&id=faa33182&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa33182",
  null
  
)

export default component.exports